import type { Ring } from '../../geo/types';
import type { BridgeDeck } from '../../site/types';
import type { PaletteModel } from '../../data/types';
import { createMeshBuilder } from '../mesh/meshBuilder';
import { meshBarriers, type Levels } from '../mesh/planBarriers';
import { buildBridges } from './bridges';

export type { Levels } from '../mesh/planBarriers';

function barriersOf(
  bridge: BridgeDeck,
  palette: PaletteModel,
  bands: readonly Levels[]
): readonly (readonly Ring[])[] {
  const builder = createMeshBuilder();
  buildBridges([bridge], palette, { builderAt: () => builder });
  const geometry = builder.finish();
  const barriers = meshBarriers(geometry, bands);
  geometry.dispose();
  return barriers;
}

/** The plan of every part of the bridges that stands between two levels, for each pair of levels
 *  asked: what a body passing at those levels would strike. It is read off the bridge meshes
 *  themselves, so a low deck, a pier, a pile or a brace stops a boat exactly where it is drawn,
 *  and a vault lets it through. */
export function bridgeBarriers(
  bridges: readonly BridgeDeck[],
  palette: PaletteModel,
  bands: readonly Levels[]
): readonly (readonly Ring[])[] {
  const perBridge = bridges.map((bridge) => barriersOf(bridge, palette, bands));
  return bands.map((_, band) => perBridge.flatMap((rings) => rings[band]!));
}
